import * as momentImported from 'moment';
import { NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
const moment = momentImported;
var DateParts;
(function (DateParts) {
    DateParts[DateParts["years"] = 0] = "years";
    DateParts[DateParts["quarters"] = 1] = "quarters";
    DateParts[DateParts["months"] = 2] = "months";
    DateParts[DateParts["weeks"] = 3] = "weeks";
    DateParts[DateParts["days"] = 4] = "days";
    DateParts[DateParts["hours"] = 5] = "hours";
    DateParts[DateParts["minutes"] = 6] = "minutes";
    DateParts[DateParts["seconds"] = 7] = "seconds";
    DateParts[DateParts["milliseconds"] = 8] = "milliseconds";
})(DateParts || (DateParts = {}));
class MtDate {
    /**
     * Create an MtDate object
     * @param dateParam the date object to use for the initial value.  Defaults to now.
     * @param asReference boolean flag indicating whether the dateParam should be handled
     * as a reference object.  Defaults to false.
     */
    constructor(dateParam, asReference = false) {
        let dateValue;
        if (!dateParam) {
            dateValue = new Date();
        }
        if (!asReference) {
            dateValue = new Date(dateParam);
        }
        else {
            dateValue = dateParam;
        }
        this.date = dateValue;
    }
    /**
     * Add to the mtDate value using a specified datePart.
     * @param amount integer amount to add.
     * @param part date part enumerator specifying which part of the date to add to.
     */
    add(amount, part) {
        const date = moment(this.date).add(amount, this.getMomentDatePart(part)).toDate();
        this.setThisDate(date);
        return this;
    }
    /**
     * Subtract from the mtDate value using a specified datePart.
     * @param amount integer amount to subtract.
     * @param part date part enumerator specifying which part of the date to subtract from.
     */
    subtract(amount, part) {
        const date = moment(this.date).subtract(amount, this.getMomentDatePart(part)).toDate();
        this.setThisDate(date);
        return this;
    }
    setThisDate(date) {
        this.date.setFullYear(date.getFullYear());
        this.date.setMonth(date.getMonth());
        this.date.setDate(date.getDate());
        this.date.setHours(date.getHours());
        this.date.setMinutes(date.getMinutes());
        this.date.setSeconds(date.getSeconds());
        this.date.setMilliseconds(date.getMilliseconds());
    }
    getMomentDatePart(part) {
        switch (part) {
            case DateParts.years:
                return 'y';
            case DateParts.quarters:
                return 'Q';
            case DateParts.months:
                return 'M';
            case DateParts.weeks:
                return 'w';
            case DateParts.days:
                return 'd';
            case DateParts.hours:
                return 'h';
            case DateParts.minutes:
                return 'm';
            case DateParts.seconds:
                return 's';
            case DateParts.milliseconds:
                return 'ms';
            default:
                return 'd';
        }
    }
    /**
     * Get a string reprensentation of the mtDate.
     * @param tokenString string including tokens that will be replaced with date parts.
     * Defaults to 'YYYY-MM-DDTHH:mm:ssZ'.
     * documented here https://momentjs.com/docs/#/displaying/format/
     */
    format(tokenString) {
        if (!tokenString) {
            return moment(this.date).format();
        }
        return moment(this.date).format(tokenString);
    }
    /**
     * Get a string representing the time from the date param to the mtDate.
     * @param date the date to start from when comparing the mtDate.  Defaults to now.
     */
    from(date) {
        if (!date) {
            date = new Date();
        }
        return moment(this.date).from(moment(date));
    }
    /**
     * Get a string representing the time from the mtDate to the date param.
     * @param date the date to end at when comparing the mtDate.  Defaults to now.
     */
    to(date) {
        if (!date) {
            date = new Date();
        }
        return moment(this.date).to(moment(date));
    }
    /**
     * Provide the mtDate as a Moment object with all of the moment
     * library functions accessible.  Will have no reference back to the mtDate object.
     * Moment documentation here http://momentjs.com/docs/
     */
    toMoment() {
        return moment(this.date);
    }
}

Object.defineProperty(Date.prototype, 'mtDate', {
    get: function () {
        return new MtDate(this, true);
    },
});
class MtDateModule {
}
MtDateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MtDateModule });
MtDateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MtDateModule_Factory(t) { return new (t || MtDateModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtDateModule, [{
        type: NgModule,
        args: [{}]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DateParts, MtDate, MtDateModule };

//# sourceMappingURL=mt-ng2-date-module.js.map